import React from "react";
import { Stack, SxProps, Theme } from "@mui/material";
import logo from "../assets/images/alenLogo.png";

export default function AlenLogo({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <Stack sx={sx}>
      <img
        style={{ maxWidth: "100%", maxHeight: "100%" }}
        src={logo}
        alt="Alen Logo"
      />
    </Stack>
  );
}
